"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Images_1 = require("../../../../misc/Images");
var styles_1 = require("./styles");
var Shapes = function (_a) {
    var version = _a.version;
    var shape1ImageProps = react_1.default.useMemo(function () {
        return (0, Images_1.getImgProps)("https://superhi.s3.amazonaws.com/assets/images/big-shapes/".concat(version, "-shape-01.png"), {
            small: 1,
            medium: 40,
            large: 35,
            xlarge: 30,
        });
    }, [version]);
    var shape2ImageProps = react_1.default.useMemo(function () {
        return (0, Images_1.getImgProps)("https://superhi.s3.amazonaws.com/assets/images/big-shapes/".concat(version, "-shape-02.png"), {
            small: 1,
            medium: 40,
            large: 35,
            xlarge: 30,
        });
    }, [version]);
    return (react_1.default.createElement(styles_1.Wrapper, { "data-component-name": "Shapes" },
        react_1.default.createElement(styles_1.ShapeWrapper, null,
            react_1.default.createElement(styles_1.ShapeFloat, null,
                react_1.default.createElement(styles_1.Shape, __assign({ alt: "" }, shape1ImageProps)))),
        react_1.default.createElement(styles_1.ShapeWrapper, null,
            react_1.default.createElement(styles_1.ShapeFloat, null,
                react_1.default.createElement(styles_1.Shape, __assign({ alt: "" }, shape2ImageProps))))));
};
exports.default = Shapes;
